exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cloud-spinner-spinner-4O3aufTgmwr{margin-top:31px}.cloud-spinner-spinner-4O3aufTgmwr>img{display:block}.cloud-spinner-circle-1qGN64uOmwr{width:90px;height:90px;-webkit-animation:cloud-spinner-circle-1qGN64uOmwr 3s infinite cubic-bezier(0.165, 0.84, 0.44, 1);animation:cloud-spinner-circle-1qGN64uOmwr 3s infinite cubic-bezier(0.165, 0.84, 0.44, 1);transform-origin:center center}@-webkit-keyframes cloud-spinner-circle-1qGN64uOmwr{0%{transform:rotate(0);opacity:1}20%{transform:rotate(144deg);opacity:0.6}40%{transform:rotate(216deg);opacity:0.8}60%{transform:rotate(360deg);opacity:0.6}80%{transform:rotate(288deg);opacity:0.8}100%{transform:rotate(360deg);opacity:1}}@keyframes cloud-spinner-circle-1qGN64uOmwr{0%{transform:rotate(0);opacity:1}20%{transform:rotate(144deg);opacity:0.6}40%{transform:rotate(216deg);opacity:0.8}60%{transform:rotate(360deg);opacity:0.6}80%{transform:rotate(288deg);opacity:0.8}100%{transform:rotate(360deg);opacity:1}}.cloud-spinner-cloud-4AMsFMVtmwr{margin-top:-90px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"spinner": "cloud-spinner-spinner-4O3aufTgmwr",
	"circle": "cloud-spinner-circle-1qGN64uOmwr",
	"cloud": "cloud-spinner-cloud-4AMsFMVtmwr"
};